<div class="ng-select-div">
  <!-- <ion-row class="flexcentercenter"> -->
  <ion-row *ngIf="data?.title">

    <ion-col size="8">
      {{data?.title ?? 'Select '+data.collection}}
    </ion-col>
    <!-- <ion-col size="4" class="ion-text-end" *ngIf="false" >
    <ion-button size="small"  fill="none" (click)="show_addedit_form=true" >+ New</ion-button>
  </ion-col> -->
  </ion-row>

  <ion-row>
    <ion-col size="9">
      <ng-select #myNgSelect *ngIf="data && !loading_select" style="margin-top:-3px ;" [items]="items"
        [loading]="custLoading" bindLabel="name" bindValue="id" [minTermLength]="typeaheadMinTermLength"
        [multiple]="data.multiple ?? false" [hideSelected]="hideSelectedOptions"
        [trackByFn]="trackByFn" [typeahead]="custTypeahead" [addTag]="canAddInDropdown ? addTagFromDropdown : false"
        [addTagText]="addTagLabel" (change)="setNewItem($event)" (clear)="onClearAll()"
        (open)="onDropdownOpen()"
        (scroll)="onContributorPanelScroll($event)"
        (scrollToEnd)="onContributorScrollToEnd()"
        (input)="onInputChange($event)" [(ngModel)]="selectedItem" [appendTo]="dropdownAppendTo"
        [dropdownPosition]="dropdownPosition"
        [clearable]="isClearable"
        [disabled]="disabled || !canEdit"
        [class.chip-truncate-select]="data.multiple && data.collection === 'contributors'">



        <!-- MT-167: dedicated label template adds a remove (X) icon to each selected chip -->
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="chip-tip-host">
            <span class="ng-value-label" [class.chip-label-truncate]="data.collection === 'contributors'">{{ chipDisplayName(item) }}</span>
            <span class="chip-hover-tip" role="tooltip">{{ chipDisplayName(item) }}</span>
          </span>
          <span class="ng-value-icon right select-remove-icon"
            (click)="onRemoveChip(item, $event, clear)" aria-label="Remove"
            title="Remove">×</span>
        </ng-template>

        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
          <div style="margin: 2px 0px;" class="card" *ngIf="item?.name">
            <div style="white-space: normal;" [ngSwitch]="data.collection">

              <ng-container *ngSwitchCase="'tracks'">

                <ion-item lines="none">
                  <ion-avatar slot="start">
                    <ion-icon style="width:100%;height:100%" name="musical-notes-outline"></ion-icon>
                  </ion-avatar>
                  <ion-label>
                    <h2> {{item?.name}}</h2>
                    <p>{{item?.isrc}}</p>

                  </ion-label>
                </ion-item>

              </ng-container>


              <ng-container *ngSwitchCase="'customers'">

                <ion-item>
                  <ion-avatar slot="start">
                    <img [src]="apiService.get_cdn_url(item?.image ?? 'e2475c9f-1923-400c-b49e-110b13c2bf49')" />
                  </ion-avatar>
                  <ion-label>
                    <h2>#{{item.idseq_app}} : {{item?.name}}</h2>
                    <p>+{{item?.mobile}}</p>
                    <ion-badge color="primary" *ngFor="let tag of item.tags">{{tag}}</ion-badge>

                  </ion-label>
                </ion-item>

              </ng-container>


              <ng-container *ngSwitchDefault>
                <b [attr.title]="item.name">{{item.name}}</b>

              </ng-container>

            </div>
          </div>
        </ng-template>

        <ng-template ng-typetosearch-tmp>
          <div class="ng-option disabled" *ngIf="data.collection !== 'contributors'">
            Start typing to search...
          </div>
        </ng-template>

        <ng-template ng-footer-tmp>
          <div class="ng-option disabled" *ngIf="data.collection === 'contributors' && contributorLoadingMore">
            Loading more...
          </div>
        </ng-template>

        <ng-template ng-notfound-tmp let-search="searchTerm">
          <div class="ng-option disabled" *ngIf="!canAddInDropdown">
            <span (click)="addItem(search)" style="cursor:pointer">Add Item "{{search}}"</span>
          </div>
        </ng-template>

      </ng-select>
    </ion-col>

    <ion-col size="3" *ngIf="data.collection!='tracks'">
      <ion-button *ngIf="canEdit && !disabled" size="small" fill="none" (click)="openAddForm()">+ New</ion-button>
    </ion-col>
  </ion-row>

</div>




<ion-modal cssClass="sa-add-item-modal" [isOpen]="show_addedit_form" (didDismiss)="closeAddForm()"
  [backdropDismiss]="true">
  <ng-template>
    <div class="sa-add-modal">
      <header class="sa-add-modal-head">
        <h3>{{ model.id ? 'Edit' : 'Add' }} {{ data.collection | titlecase }}</h3>
        <button type="button" class="sa-add-modal-close" (click)="closeAddForm()" aria-label="Close">
          <ion-icon name="close-outline"></ion-icon>
        </button>
      </header>
      <form class="sa-add-modal-body" (ngSubmit)="otherFormSubmit()" ngNativeValidate>
        <label class="sa-add-field">
          <span>Name</span>
          <input type="text" [(ngModel)]="model.name" name="name" required
            placeholder="Enter name" autocomplete="off" />
        </label>
        <label class="sa-add-field" *ngIf="data.collection === 'customers'">
          <span>Mobile</span>
          <input type="tel" [(ngModel)]="model.mobile" name="mobile" required placeholder="Enter mobile" />
        </label>
        <div class="sa-add-modal-actions">
          <button type="button" class="sa-btn sa-btn-ghost" (click)="closeAddForm()">Cancel</button>
          <button type="submit" class="sa-btn sa-btn-primary" [disabled]="loading_select">
            {{ loading_select ? 'Saving…' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </ng-template>
</ion-modal>